// @flow

export const getCatalogs = (state) => state.catalog.catalogs;

export const getSelectedCatalogId = (state) => state.catalog.selected;
